import screenfull from 'screenfull'

/**
 * Determines whether or not the browser is currently fullscreen.
 * Screenfull is Google's suggested third-party for cross-browser compatibility
 */
const isFullscreen = (): boolean => screenfull.isEnabled && screenfull.isFullscreen

export default isFullscreen
